import { getObjectKeysAsObject } from "@checkout/helpers";
import { BaggageGuards } from "@checkout/states";
import { seatsGuards } from "../../../modules/flight-checkout/guards/seats";
import type { FlightMachineContext } from "../../../modules/flight-checkout/types";

export const guards = {
  isBaggageAndSeatsEligible: (ctx: FlightMachineContext) => {
    return (
      BaggageGuards.isBaggageEligible(ctx) &&
      seatsGuards.hasSeatMapAvailability(ctx, undefined)
    );
  },
};

export const GuardTypes = getObjectKeysAsObject(guards);
